module.exports = __webpack_public_path__ + "img/02.a343f256.svg";